import React from 'react';

const AngleLines = ({sensor, lastmeasurements}) => {
  const centerX = 150;
  const centerY = 150;
  const length = 120;

  // Viimeisimmät mittaukset oikealta laitteelta
  console.log('anglelines:', sensor, lastmeasurements[sensor])
  let x_angle = 0.0;
  let y_angle = 0.0;
  let z_angle = 0.0;

  if (sensor !== null && lastmeasurements[sensor] !== undefined) {
    x_angle = lastmeasurements[sensor]['x_angle_with_offset'];
    y_angle = lastmeasurements[sensor]['y_angle_with_offset'];
    z_angle = lastmeasurements[sensor]['z_angle_with_offset'];
  }


// stroke={`url(#${gradientId})`} -> stroke="white"  

  const gradients = [
    { id: 'grad1', angle: x_angle, colors: ['#00ffff', '#0044ff'], color:'#ff0000' },
    { id: 'grad2', angle: y_angle, colors: ['#ff00ff', '#ff8800'], color:'#00ff00' },
    { id: 'grad3', angle: z_angle, colors: ['#ffaa00', '#ff0000'], color:'#0000ff' },
  ];

  const drawLine = (angleDeg, gradientId, color) => {
    const angleRad = (angleDeg * Math.PI) / 180;
    const dx = Math.cos(angleRad) * length;
    const dy = Math.sin(angleRad) * length;

    return (
      <line
        key={gradientId}
        x1={centerX - dx}
        y1={centerY - dy}
        x2={centerX + dx}
        y2={centerY + dy}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    );
  };

  return (
    <div style={{ width: '300px', margin: 'auto' }}>
      <svg viewBox="0 0 300 300" style={{ width: '100%', background: 'linear-gradient(135deg, #69d5e0, #004466)', borderRadius: '50%' }}>
        <defs>
          {gradients.map(({ id, colors }) => (
            <linearGradient key={id} id={id} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor={colors[0]} />
              <stop offset="100%" stopColor={colors[1]} />
            </linearGradient>
          ))}
        </defs>

        {gradients.map(({ id, angle, color }) => drawLine(angle, id, color))}

        {/* Keskipiste */}
        <circle cx={centerX} cy={centerY} r="4" fill="white" />
      </svg>

 {/* Numeronäyttö */}
      <div
        style={{
          background: 'linear-gradient(135deg, #69d5e0, #004466)',
          padding: '10px',
          borderRadius: '10px',
          marginTop: '10px',
          textAlign: 'left',
          fontSize: '14px',
          lineHeight: '1.6',
          color: '#ffffff'
        }}
      >
        <div><span style={{ color: '#00ffff' }}>⦿</span> x: {x_angle.toFixed(3)}°</div>
        <div><span style={{ color: '#ff00ff' }}>⦿</span> y: {y_angle.toFixed(3)}°</div>
        <div><span style={{ color: '#ffaa00' }}>⦿</span> z: {z_angle.toFixed(3)}°</div>
      </div>      
    </div>
  );
};

export default AngleLines;


